module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDI3IDIxIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjRkZGIiBkPSJNMjUuODQgMTAuMDY0bC0xMC04Ljk0YS41MDguNTA4IDAgMCAwLS44NC4zOHY1LjQzSDIuMjVjLS42OSAwLTEuMjUuNTYtMS4yNSAxLjI1djQuNWMwIC42OS41NiAxLjI1IDEuMjUgMS4yNWgxMi43NnY1LjVjMCAuMi4xMi4zOC4zLjQ2LjA3LjAzLjEzLjA0LjIuMDQuMTIgMCAuMjQtLjA0LjMzLS4xM2wxMC05YS40OC40OCAwIDAgMCAuMTctLjM3LjQ4LjQ4IDAgMCAwLS4xNy0uMzd6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forward-arrow-icon.svg
// module id = 2741
// module chunks = 0